"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DateInput;

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _pickers = require("@material-ui/pickers");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

DateInput.propTypes = {
  options: _propTypes["default"].object,
  onClose: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].any,
  placeholder: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};

function DateInput(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      onClose = _ref.onClose,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled;
  var includeTime = options === null || options === void 0 ? void 0 : options.includeTimeField;
  var timeFormat = options === null || options === void 0 ? void 0 : options.timeFormat;
  return /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _moment["default"]
  }, includeTime ? /*#__PURE__*/_react["default"].createElement(_pickers.DateTimePicker, {
    id: "date-editor",
    autoOk: true,
    disabled: disabled,
    value: value,
    onChange: onChange,
    ampm: timeFormat === 12 ? true : false,
    variant: "inline",
    inputVariant: "outlined",
    size: "small",
    format: timeFormat === 12 ? "MM/DD/YYYY hh:mm a" : "MM/DD/YYYY HH:mm",
    onClose: onClose,
    fullWidth: true,
    InputProps: {
      style: {
        fontSize: 14
      },
      placeholder: placeholder
    }
  }) : /*#__PURE__*/_react["default"].createElement(_pickers.DatePicker, {
    id: "date-editor",
    autoOk: true,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onClose: onClose,
    variant: "inline",
    size: "small",
    format: "MM/DD/YYYY",
    inputVariant: "outlined",
    fullWidth: true,
    InputProps: {
      style: {
        fontSize: 14
      },
      placeholder: placeholder
    }
  }));
}